import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Modal, Button, Row, Col, Carousel } from 'react-bootstrap'
import SimpleFormat from '@16g/react-simple-format'
import BookNowButton from '../../ui/BookNowButton'
import Slider from '../../ui/Slider'

function extractSlidesFromBackdrop(backdrop) {
  let slides = []

  if(backdrop.attributes.thirdPartyVideoId) {
    slides.push({ type: "video", videoId: backdrop.attributes.thirdPartyVideoId })
  }

  if(backdrop.attributes.primaryImage && backdrop.attributes.primaryImage.videoVariant) {
    slides.push({type: "image", url: backdrop.attributes.primaryImage.videoVariant})
  }

  backdrop.attributes.additionalImages.forEach(image => {
    if(image && image.videoVariant) {
      slides.push({type: "image", url: image.videoVariant})
    }
  })

  return slides
}

@inject("modalContainer")
@observer
export default class PhotoboothBackgroundModal extends React.Component {
  static propTypes = {
    photoboothBackground: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    modalContainer: PropTypes.any.isRequired,
    showPrice: PropTypes.bool.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired,
    fontFamily: PropTypes.string
  }

  render() {
    const { show, onClose, modalContainer, photoboothBackground, showPrice, showBookNowButton, bookNowButtonText, fontFamily } = this.props

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        container={modalContainer}
        style={{ fontFamily }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{ photoboothBackground.attributes.name }</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={8}>
              <Slider slides={extractSlidesFromBackdrop(photoboothBackground)} />
            </Col>
            <Col sm={4}>
              <SimpleFormat text={photoboothBackground.attributes.description} />

              { (showPrice && photoboothBackground.attributes.priceFormatted) &&
                <div style={{...styles.price, fontFamily}}>
                  { photoboothBackground.attributes.priceFormatted }
                </div>
              }
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <BookNowButton showBookNowButton={showBookNowButton} bookNowButtonText={bookNowButtonText} />
          <Button onClick={onClose} >Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const styles = {
  price: {
    textAlign: "right",
    fontSize: 18,
    fontWeight: "bold"
  }
}
